import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { IEmployeeSummaryInfo } from 'app/shared/model/employee-summary-info.model';
import { formatDate } from '@angular/common';
import { IAttachmentDocument } from '@appshared';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  protected resourceUrl = '/hrm-portal-api/api/documents/';

  constructor(
    public http: HttpClient,
    private _fuseProgressBarService: FuseProgressBarService
  ) {}

  uploadFile(file: File, description: string, type: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('description', description);
    formData.append('type', type);
    return this.http.post<IAttachmentDocument>(`${this.resourceUrl}`, formData);
  }
}
